/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "svr8",
  title: "Hi all, I'm Shikhar",
  subTitle: emoji(
    "I specialise in Full-Stack Software Development. Having worked around remote-control systems, video-conferencing apps and analytics portals, I developed a strong interest in real-time systems. Lets see how I grew into this."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1HBUMJXQ6pF58hd5HymaRdtvpubYWbjrM/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/svr8",
  linkedin: "https://www.linkedin.com/in/shikhar-vaish/",
  gmail: "shikhar.vaish@nyu.edu",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://svr8.medium.com",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "Enjoy building collaboration tools and solving problems around scaling systems.",
  skills: [
    emoji(
      "• Develop highly interactive systems for people in creative fields."
    ),
    emoji("• Strong inclination towards collaborative and scalable systems."),
    emoji("• Look forwards to working with functional teams and networking.")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "next.js/react",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },

    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "New York University",
      logo: require("./assets/images/nyu.png"),
      subHeader: "Master of Science in Computer Engineering",
      duration: "September 2021 - May 2023",
      desc: "Pariticipation in Web and Security Projects",
      descBullets: [
        "Worked in network security to prevent Man-In-The-Middle attacks.",
        "Designed a Crowdsourced Computing Protocol for web apps.",
        "Built a webapp to analyse people's vision based to aid online diagnosis in optics."
      ]
    },
    {
      schoolName: "Manipal University Jaipur",
      logo: require("./assets/images/muj.png"),
      subHeader: "Bachelor of Technology in Computer Science",
      duration: "August 2017 - May 2021",
      desc: "Developed industry skills and worked on multi-disciplinary projects.",
      descBullets: [
        "Developed and launched collaborative book-writing platform during Startup Weekend and gained 50+ users in a month.",
        "Worked with in Mars Rover team to publish path planning papers and build remote-control system and ranked under top 60 among 200+ international teams.",
        "Built competitive programming portal for intra-college events used in college technical fests."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section
// antrikshlabslogo.jpeg
const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Developer",
      company: "New York University",
      companylogo: require("./assets/images/nyu.png"),
      date: "September 2021 – January 2022",
      descBullets: [
        "Built module to record user’s reading speed using component load-timestamps in Javascript",
        "Reduced application assets load-time to 1.5s by lazy-loading assets and adding caching.",
        "Saved scientists’ 15m debugging time by building module to parse CSVs and visualize errors."
      ]
    },
    {
      role: "Software Engineer",
      company: "Antriksh Labs Private Limited",
      companylogo: require("./assets/images/antrikshlabslogo.jpeg"),
      date: "Aug 2020 – Aug 2021",
      descBullets: [
        "Implemented in-memory caching on client-side and server-side apps.",
        "Visualised real-time sensor data using Prometheus and Redis.",
        "Communicated in Agile Environment and wrote API documentation using Swagger."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Dell Technologies",
      companylogo: require("./assets/images/dell.jpeg"),
      date: "Feb 2021 – May 2021",
      descBullets: [
        "Integrated SSO authentication service for 1000+ Dell internal teams using Angular.",
        "Improved search performance by 10% by designing tags SQL database and writing APIs using C#, .NET.",
        "Communicated in Agile Environment and wrote API documentation using Swagger."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Dell Technologies",
      companylogo: require("./assets/images/dell.jpeg"),
      date: "Feb 2020 – July 2020",
      descBullets: [
        "Wrote API tests in Swagger and maintained documentation using Postman, resulting in a 20% reduction in bugs and errors.",
        "Re-engineered sales pipeline backend by combining endpoints based on database model in C# and .NET, resulting in a 30% increase in overall system efficiency."
      ]
    },

    {
      role: "Software Developer Intern",
      company: "CargoDocker",
      companylogo: require("./assets/images/startup-template-logo.webp"),
      date: "Dec 2019 – April 2020",
      descBullets: [
        "Developed management APIs with advanced filters using Java SpringBoot.",
        "Created customer order dashboard with pagination and lazy loading using React.",
        "Maintained repository on GitHub and wrote technical documentation for backend."
      ]
    },
    {
      role: "Backend Developer Intern",
      company: "GroceriStar",
      companylogo: require("./assets/images/groceristar.jpeg"),
      date: "June 2019 – August 2019",
      descBullets: [
        "Designed APIs to deliver large datasets and reduced response time to 80ms.",
        "Helped to convert Node.js modules to ES6 syntax and assisted with technical documentation.",
        "Write unit tests for upgraded methods and developed integration test for multiple modules."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Featured Projects",
  subtitle:
    "Some projects that attracted multiple clients and job opportunities.",
  projects: [
    {
      image: require("./assets/images/gptvoice.png"),
      projectName: "GPT Voice",
      projectDesc:
        "Wrapper on GPT API to speak to AI assitants and hear back in real-time.",
      footerLink: [
        {
          name: "See Demo",
          url: "https://comrad.vercel.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/portfolio-whiteboard.png"),
      projectName: "Collaborative Book Writing Platform",
      projectDesc: "The demo showcases the whiteboard.",
      footerLink: [
        {
          name: "See Demo",
          url: "https://shabd-ui.vercel.app/workspace/treeview"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/portfolio-text-editor.png"),
      projectName: "Lotus Docs",
      projectDesc: "Text-Editor for the web, insipired by Notion and ROS.",
      footerLink: [
        {
          name: "See demo",
          url: "https://portfolio-text-editor.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/portfolio-ide.png"),
      projectName: "Desk - A Minimal IDE",
      projectDesc:
        "A Desktop Application for competitive programmers, focused on fast algorithm implementation.",
      footerLink: [
        {
          name: "Github",
          url: "https://github.com/svr8/Desk"
        },
        {
          name: "Downloads",
          url: "https://github.com/svr8/Desk#downloads"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "First Position at John Snow Labs Hackathon 2020",
      subtitle:
        "Won $1500 cash prize for building NLP chatbot for the agriculture industry.",
      image: require("./assets/images/john-snow-labs.jpeg"),
      imageAlt: "John Snow Labs Logo",
      footerLink: [
        {
          name: "John Snow Labs Blog",
          url: "https://www.johnsnowlabs.com/john-snow-labs-announces-the-3-winners-of-the-nlp-summit-hackathon/"
        }
      ]
    },
    {
      title: "Best Paper at IEEE PDGC 2020",
      subtitle:
        "First Author of the paper 'Segmented Approach to Path Planning' that performed 51% faster than state of the art A* path planning algorithm.",
      image: require("./assets/images/ieee.jpeg"),
      imageAlt: "IEEE Logo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1GVpBSgMGtSF5QgOLZRugYvBWw0Fx6pCb/view?usp=sharing"
        },
        {
          name: "Github Repo",
          url: "https://github.com/svr8/SegmentedPathPlanner"
        },
        {
          name: "IEEE Paper",
          url: "https://ieeexplore.ieee.org/document/9315788"
        }
      ]
    },

    {
      title: "First Positon at SEARCC ISSC 2016",
      subtitle:
        "Won International Competitive Programming Competiton, represented Indian team.",
      image: require("./assets/images/csi.jpeg"),
      imageAlt: "CSI Logo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1QoSLpP0q_ucSRdNa91A1r4BWouQLbgJK/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1 332 217 8370",
  email_address: "shikhar.vaish@nyu.edu"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
